import React from 'react';

class SeparateLine extends React.Component {
  render() {
    return <hr className={this.props.className} />;
  }
}

export default SeparateLine;
